module.exports = __webpack_public_path__ + "assets/img/StockF10.e5d476e5.png";